import React, {  useEffect,useCallback,useState } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next" 
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';  
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Grid from '@mui/material/Grid';
import Textarea from '@mui/joy/Textarea';
import Typography from '@mui/material/Typography'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Stack from '@mui/material/Stack';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import { setLoading } from 'reducers/loadingSlice';
import { NumericFormat } from 'components/utils/NumericFormat';
import PropTypes from 'prop-types'; 

const initialStateArticle = {
  id: "",
  titlees: "",
  titleen: "",
  subtitlees: "",
  subtitleen: "",
  owncode: "",
  codean: "",
  barcode: "",
  accountingcode:"",
  location: "",
  marca: "",
  model: "",
  createdate: "",
  applytypesofsize: false,
  applycolor: false,
  applynumserial: false,
  isnewpiece: true,
  modifystock:false,   
  minimumstock:0,
  maximumstock:0,
  actualstock:0,
  averagepurchaseprice:0,  
  lastpurchaseprice:0,
  datelastpurchaseprice: "",
  comments: "",
  salesunits_id:0,
  salesunits_namees: "",
  salesunits_nameen: "",
  salesunits_unitbase:0,  
  salesunits_quantityonbaseunit:0,  
  salesunits_symbol: "",
  department_id:0,
  department_code: "",
  department_namees: "",
  department_nameen: "",
  section_id:0,
  section_code: "",
  section_namees: "",
  section_nameen: "",
  subsection_id:0,
  subsection_code: "",
  subsection_namees: "",
  subsection_nameen: "",
  typesoftax_id:0,
  typesoftax_namees: "",
  typesoftax_nameen: "",
  typesoftax_tax:0,
  typesoftax_taxinclude:false,
  defaultprovider_id:0,
  defaultprovider_tradename: "",
  defaultprovider_documentid: "",
  lastprovider_id:0,
  lastprovider_tradename: "",
  lastprovider_documentid: "",
  color_id:0,
  color_code: "",
  color_namees: "",
  color_nameen: "",
  codeler_id:0,
  codeler_code: "",
  codeler_namees: "",
  codeler_nameen: "",
  articlesizes: [],
  articlecolors: [],
  articleimages: [],
  articlestoretypesofprices: [],
  articlestorenumseriales: []
};
 
 
const ViewArticleDetails = ({ id, openViewDetails,setOpenViewDetails}) => {
const { t, i18n } = useTranslation(['listDataArticles']);
const token = useSelector((state) => state.loginUser.token);  
const [formArticleDetails, setFormArticleDetails] = useState(initialStateArticle); 
const roles = useSelector((state) => state.loginUser.roles);  
const showExtendedFilter = !!roles?.[0]?.listmenus?.find((key) => key.name === "Handle_Article_View_Extemded");
const dispatch = useDispatch();
 
    const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openViewDetails) {
        setFormArticleDetails(initialStateArticle);
        setFormArticleDetails(formArticleDetails => ({
          ...formArticleDetails,
          articlestoretypesofprices : [],
          articleimages:[],
          articlesizes : [],
          articlecolors : [],
          articlestorenumseriales : [] 
        })); 
        dispatch(setLoading(false));
        setOpenViewDetails(false);
      }
    },
    [ setFormArticleDetails,  
      dispatch, 
      openViewDetails, 
      setOpenViewDetails]
  );

  const closeModalViewDetails = () => { 
    setFormArticleDetails(initialStateArticle);
    setFormArticleDetails(formArticleDetails => ({
      ...formArticleDetails,
      articlestoretypesofprices : [],
      articleimages:[],
      articlesizes : [],
      articlecolors : [],
      articlestorenumseriales : [] 
    })); 
    dispatch(setLoading(false));
    setOpenViewDetails(false);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]); 

   const toggleDrawerFormatDI = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      closeModalViewDetails();
      return;
    }
  };
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get2(ENDPOINT, `articles/getarticlebyid/`, token, id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setFormArticleDetails(initialStateArticle);
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setFormArticleDetails(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (openViewDetails){
      if (id !== "0") {
        fetchDataArticle();
        dispatch(setLoading(false));
      }  
    }
    return () => { isMounted = false };
  
  }, [dispatch, id, t, token, formArticleDetails.id,setFormArticleDetails,openViewDetails]);

  return (
    <>
      {openViewDetails && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerFormatDI(false)}
            onOpen={toggleDrawerFormatDI(true)}
          >
            <Container >
             <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '900px' }}>
                <br/>
                {/* HEADER */}
                <div className="email-card-header">
                  <div className="email-header-content">
                    <div className="email-header-text">
                      <div className="email-header-title">
                         {t('Text_Data')}
                      </div>
                      <div className="email-header-number">
                        {formArticleDetails.titlees || '-'}
                      </div>
                    </div>
                    <div className="email-card-actions"> 
                      <button type="button" className="email-cancel-btn" onClick={closeModalViewDetails} >
                        {t('Button_Back')}
                      </button> 
                    </div>
                  </div>
                </div> 
                <br/>  
                <form className="createformatdi" onSubmit={closeModalViewDetails}> 
                   <div className="email-card-form">
                    <div className="card-body"> 
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_titlees').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formArticleDetails.titlees || '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_subtitlees').toUpperCase()}
                          </Typography>
                          <Textarea 
                              id="subtitlees" 
                              name="subtitlees"
                              value={formArticleDetails.subtitlees}
                              sx={{fontSize: '18px'} }
                              variant="standard"
                              maxRows={8}
                              disabled
                            />  
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_owncode').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formArticleDetails.owncode || '-'}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_eancode').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formArticleDetails.codean || '-'}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_barcode').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formArticleDetails.barcode || '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Accountingcode').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formArticleDetails.accountingcode || '-'}
                          </Typography>
                        </Grid>
                       
                        {showExtendedFilter &&
                          <>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_location').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.location || '-'}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Marca').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.marca || '-'}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Model').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.model || '-'}
                              </Typography>
                            </Grid>
                          </>
                        }
                        
                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_salesunits').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {i18n.language==='es'?formArticleDetails.salesunits_namees:formArticleDetails.salesunits_nameen || '-'}
                          </Typography>
                        </Grid>
                         <Grid item xs={6}></Grid>

                         <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Department').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {i18n.language==='es'?formArticleDetails.department_namees:formArticleDetails.department_nameen || '-'}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Section').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {i18n.language==='es'?formArticleDetails.section_namees:formArticleDetails.section_nameen || '-'}
                           </Typography>
                        </Grid>

                         <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Group').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {i18n.language==='es'?formArticleDetails.subsection_namees:formArticleDetails.subsection_nameen || '-'}
                           </Typography>
                        </Grid>
                        {showExtendedFilter &&
                          <>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Defaultprovider_Businessname').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.defaultprovider_tradename || '-'}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Lastprovider_Businessname').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.lastprovider_tradename || '-'}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Averagepurchaseprice').toUpperCase()}
                              </Typography>
                              <NumericFormat
                                style={{color:"#000000", align:'right', fontSize: 18}}
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                suffix={" €"}
                                fixedDecimalScale= {true}
                                displayType="text"
                                value={formArticleDetails.averagepurchaseprice || '-'}
                                disabled={true}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Lastpurchaseprice').toUpperCase()}
                              </Typography>
                              <NumericFormat
                                style={{color:"#000000", align:'right', fontSize: 18}}
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                suffix={" €"}
                                fixedDecimalScale= {true}
                                displayType="text"
                                value={formArticleDetails.lastpurchaseprice || '-'}
                                disabled={true}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Datelastpurchaseprice').toUpperCase()}
                              </Typography>
                              <Typography style={{color:"black", fontSize: 18}}>
                                {formArticleDetails.datelastpurchaseprice!==null && formArticleDetails.datelastpurchaseprice!==""?new Date(formArticleDetails.datelastpurchaseprice).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}
                              </Typography>
                            </Grid>
                          </>
                        }
                        <Grid item xs={6}>
                          <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Purchasetypesoftax_Namees').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {i18n.language==='es'?formArticleDetails.typesoftax_namees:formArticleDetails.typesoftax_nameen || '-'}
                          </Typography>
                        </Grid>
                        {showExtendedFilter &&
                          <>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Modifystock').toUpperCase()}
                              </Typography>
                              <Checkbox checked={formArticleDetails.modifystock} 
                                style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                
                                }}
                                disabled
                              /> 
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Minimumstock').toUpperCase()}
                              </Typography>
                              <NumericFormat
                                style={{color:"#000000", align:'right', fontSize: 18}}
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2} 
                                fixedDecimalScale= {true}
                                displayType="text"
                                value={formArticleDetails.minimumstock || '-'}
                                disabled={true}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Maximumstock').toUpperCase()}
                              </Typography>
                              <NumericFormat
                                style={{color:"#000000", align:'right', fontSize: 18}}
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2} 
                                fixedDecimalScale= {true}
                                displayType="text"
                                value={formArticleDetails.maximumstock || '-'}
                                disabled={true}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Actualstock').toUpperCase()}
                              </Typography>
                              <NumericFormat
                                style={{color:"#000000", align:'right', fontSize: 18}}
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2} 
                                fixedDecimalScale= {true}
                                displayType="text"
                                value={formArticleDetails.actualstock || '-'}
                                disabled={true}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_typesofsize_Apply').toUpperCase()}
                              </Typography>
                              <Checkbox checked={formArticleDetails.applytypesofsize} 
                                style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                
                                }}
                                disabled
                              />  
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_numserial_Apply').toUpperCase()}
                              </Typography>
                              <Checkbox checked={formArticleDetails.applynumserial} 
                                style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                
                                }}
                                disabled
                              />   
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_isNewPiece').toUpperCase()}
                              </Typography>
                              <Checkbox checked={formArticleDetails.isnewpiece} 
                                style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                
                                }}
                                disabled
                              />  
                            </Grid>
                            <Grid item xs={6}>
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_color_Apply').toUpperCase()}
                              </Typography>
                              <Checkbox checked={formArticleDetails.applycolor} 
                                style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                
                                }}
                                disabled
                              />   
                            </Grid> 
                          </>
                        }
                        <Grid item xs={12}>
                           <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 18}}>
                            {t('Text_Stores_Article_Price').toUpperCase()}
                          </Typography>
                          {formArticleDetails.articlestoretypesofprices!==undefined && formArticleDetails.articlestoretypesofprices!==null && formArticleDetails.articlestoretypesofprices && formArticleDetails.articlestoretypesofprices.length > 0 ? (
                            formArticleDetails.articlestoretypesofprices.map((row, index) => (
                              <Typography key={index} style={{ color: "black", fontSize: 18 }}>
                                <Checkbox checked={row.enablestorearticleprice} 
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                  
                                  }}
                                  disabled
                                />&nbsp;-&nbsp;{i18n.language==='es'?row.typesofprice_namees:row.typesofprice_nameen || '-'}&nbsp;-&nbsp;  
                                <NumericFormat
                                  style={{color:"#000000", align:'right', fontSize: 18}}
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2} 
                                   suffix={" €"}
                                  fixedDecimalScale= {true}
                                  displayType="text"
                                  value={row.saleprice || '0.00'}
                                  disabled={true}
                                />
                              </Typography>
                              
                            ))
                          ) : (
                            <Typography style={{ color: "gray", fontSize: 16 }}>
                              {t('Text_NOT_REPORTING')}
                            </Typography>
                          )} 
                        </Grid>
                        {showExtendedFilter &&
                          <>
                            <Grid item xs={6}>
                              <Divider sx={{ my: 2 }} />
                              <Typography style={{color:"#4e73df", fontSize: 18}}>
                                {t('Text_Filter_Notapplytypesofsize').toUpperCase()}
                              </Typography>
                              {formArticleDetails.articlesizes!==undefined && formArticleDetails.articlesizes!==null && formArticleDetails.articlesizes && formArticleDetails.articlesizes.length > 0 ? (
                                formArticleDetails.articlesizes.map((row, index) => (
                                  <Typography key={index} style={{ color: "black", fontSize: 18 }}>
                                    <Checkbox checked={row.enabletypesofsizearticle} 
                                      style={{color:"#4e73df", fontSize: 18, paddingLeft:0}} 
                                      sx={{
                                        '& .MuiSvgIcon-root': { fontSize: 28 }, 
                                      
                                      }}
                                      disabled
                                    />&nbsp;-&nbsp;{i18n.language==='es'?row.typeofsize_namees:row.typeofsize_nameen}&nbsp;-&nbsp;{row.typeofsize_symbolsizes}
                                  </Typography>
                                ))
                              ) : (
                                <Typography style={{ color: "gray", fontSize: 16 }}>
                                  {t('Text_Filter_Notapplytypesofsize').toUpperCase()}
                                </Typography>
                              )} 
                            </Grid>
                          <Grid item xs={6}>
                              <Divider sx={{ my: 2 }} />
                                <Typography style={{ color: "#4e73df", fontSize: 18 }}>
                                  {t('Text_Article_Color').toUpperCase()}
                                </Typography>
                                {formArticleDetails.articlecolors !== undefined &&
                                  formArticleDetails.articlecolors !== null &&
                                  formArticleDetails.articlecolors &&
                                  formArticleDetails.articlecolors.length > 0 ? (
                                  formArticleDetails.articlecolors.map((row, index) => (
                                    <Stack 
                                      key={index} 
                                      direction="row" 
                                      spacing={1} 
                                      alignItems="center"
                                      sx={{ my: 1 }}
                                    >
                                      <Checkbox 
                                        checked={row.enablecolorarticle}
                                        style={{ color: "#4e73df", fontSize: 18, paddingLeft: 0 }}
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        disabled
                                      />
                                      <Typography style={{ color: "black", fontSize: 18 }}>
                                        - {i18n.language==="es" ? row.color_namees : row.color_nameen} -
                                      </Typography>
                                      <Box 
                                        sx={{ width: 60, height: 15, backgroundColor: row.color_codehex }} 
                                      />
                                    </Stack>
                                  ))
                                ) : (
                                  <Typography style={{ color: "gray", fontSize: 16 }}>
                                    {t('Text_Filter_Notapplycolor').toUpperCase()}
                                  </Typography>
                              )} 
                            </Grid>

                            <Grid item xs={12}>
                              <Divider sx={{ my: 2 }} />
                                <Typography style={{ color: "#4e73df", fontSize: 18 }}>
                                  {t('Text_NumSeriales_ArticleStore').toUpperCase()}
                                </Typography>
                                {formArticleDetails.articlestorenumseriales !== undefined &&
                                  formArticleDetails.articlestorenumseriales !== null &&
                                  formArticleDetails.articlestorenumseriales &&
                                  formArticleDetails.articlestorenumseriales.length > 0 ? (
                                  formArticleDetails.articlestorenumseriales.map((row, index) => (
                                    <Stack 
                                      key={index} 
                                      direction="row" 
                                      spacing={1} 
                                      alignItems="center"
                                      sx={{ my: 1 }}
                                    >
                                      <Typography style={{ color: "black", fontSize: 18 }}>
                                        {row.substore_name}
                                      </Typography>
                                      {formArticleDetails.applytypesofsize && row.typeofsize_id===null?t('Text_Filter_notapplycolor'):
                                        <Typography style={{ color: "black", fontSize: 18 }}>
                                          - {(i18n.language==="es"?row.typeofsize_namees:row.typeofsize_nameen)}
                                        </Typography>
                                      }  
                                      {formArticleDetails.applycolor && row.color_id===null?t('Text_Filter_notapplycolor'):
                                        <Box 
                                          sx={{ width: 60, height: 15, backgroundColor: row.color_codehex }} 
                                        />
                                      }
                                      <Typography style={{ color: "black", fontSize: 18 }}>
                                        - {row.serialnumber} 
                                      </Typography>
                                    </Stack>
                                  ))
                                ) : (
                                  <Typography style={{ color: "gray", fontSize: 16 }}>
                                    {t('Text_Filter_Applynotnumserial').toUpperCase()}
                                  </Typography>
                              )} 
                            </Grid>
                            <Grid item xs={12}>
                              <Divider sx={{ my: 2 }} />
                              <Typography style={{ color: "#4e73df", fontSize: 18 }}>
                                {t('Text_Images_Article')}
                              </Typography>

                              {formArticleDetails.articleimages &&
                              formArticleDetails.articleimages.length > 0 ? (
                                <ImageList variant="masonry" cols={4} gap={8}>
                                  {formArticleDetails.articleimages.map((item, keyData) => {
                                    const titleText = i18n.language === 'es'
                                      ? (item.titlees || '')
                                      : (item.titleen || '');
                                    const shortTitle = titleText.length > 14 ? titleText.substring(0, 14) : titleText;

                                    return (
                                      <ImageListItem key={item.id || keyData}>
                                        <img
                                          src={`data:${item.type};base64,${item.datafile}`}
                                          alt={item.imageshield_filename || shortTitle || 'image'}
                                          loading="lazy"
                                          style={{ borderRadius: 8, width: '100%', height: 'auto' }}
                                        />
                                        <ImageListItemBar
                                          position="top"
                                          title={shortTitle}
                                          sx={{
                                            pl: 0,
                                            pr: 1,
                                            background:
                                              'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)'
                                          }}
                                        />
                                      </ImageListItem>
                                    );
                                  })}
                                </ImageList>
                              ) : (
                                <Typography style={{ color: "gray", fontSize: 16 }}>
                                  {t('Text_NOT_REPORTING')}
                                </Typography>
                              )}
                            </Grid>
                          </>
                        }

                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_Comments').toUpperCase()}
                          </Typography>
                          <Textarea 
                            id="comments" 
                            name="comments"
                            value={formArticleDetails.comments }
                            sx={{width: 860, fontSize: 18} }
                            variant="standard"
                            maxRows={8}
                            disabled
                          />   
                        </Grid>
                      </Grid> 
                    </div> 
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>    
        </div>
      } 
    </>
  )
}

ViewArticleDetails.propTypes = {
  openViewDetails: PropTypes.bool.isRequired,
  setOpenViewDetails: PropTypes.func.isRequired 
};

export default ViewArticleDetails;